import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import VariantReader from "aldoo-ra/VariantReader"
import DynamicSVG from "aldoo-ra/DynamicSVG"
import { twMerge } from "tailwind-merge"

const Icon = ({
  id,
  variant = "md",
  styleOverrides,
  recolor = false,
  className = "",
  alt = "icon",
  fallbackSrc,
}) => {
  // Get variant class from VariantReader
  const variantClass = VariantReader.useVariant({
    componentName: "Icon",
    variant,
    styleOverrides,
  })

  // Use twMerge to combine classes (no need for hasCustomSize check)
  const finalClassName = twMerge(variantClass, className)

  // Use CMSRender with fallback handling
  return (
    <CMSRender
      contentType="Icon"
      match={{
        "content.id": id,
      }}
      page={1}
      itemsPerPage={1}
      renderItem={(icon) => {
        // Safety check for icon.image
        if (!icon || !icon.image || typeof icon.image !== 'string') {
          return null
        }
        
        const isSVG = icon.image.includes(".svg")
        return isSVG ? (
          <DynamicSVG
            url={icon.image}
            recolor={recolor}
            alt={icon.title || alt}
            className={finalClassName}
          />
        ) : (
          <img
            src={icon.image}
            alt={icon.title || alt}
            className={finalClassName}
          />
        )
      }}
      fallback={() => {
        // If no CMS data and no fallback, return nothing
        if (!fallbackSrc) {
          return null
        }

        // If fallback provided, use fallback
        const isSVG = fallbackSrc.includes(".svg")
        return isSVG ? (
          <DynamicSVG
            url={fallbackSrc}
            recolor={recolor}
            alt={alt}
            className={finalClassName}
          />
        ) : (
          <img
            src={fallbackSrc}
            alt={alt}
            className={finalClassName}
          />
        )
      }}
    />
  )
}

export default Icon
